// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageMediumFragmentDoc } from '../../imageMedium.fragment.generated';
import { LinkFragmentDoc } from '../../index.generated';
export const SquareImageBoxFragmentDoc = gql`
    fragment squareImageBox on SquareImageBox {
  __typename
  image {
    ...imageMedium
  }
  link {
    ...link
  }
}
    ${ImageMediumFragmentDoc}
${LinkFragmentDoc}`;